export const environment = {
  production: true,
  isSentry: true,
  baseUrl: 'https://devapi.cogwheelanalytics.com/api',
  newBaseUrl: 'https://devapinewarc.cogwheelanalytics.com',
  facebook: {
    appId: '599907791161411',
    cookie: true,
    xfbml: true,
    version: 'v18.0',
  },
  knowledgeBase: {
    cogwheelAnalytic:
      'https://docs.google.com/document/d/1C86e4ro1neUOb5s2q79x5jZxOqNXFdFAI6sJbLLw3Lw/edit?usp=sharing',
  },
  hotelRequest: {
    addHotel: 'https://forms.clickup.com/10554421/f/a231n-61251/2UPU35HNZNRCRG4BPB',
    removeHotel: 'https://forms.clickup.com/10554421/f/a231n-62591/CS6XQ8AKPS6DGBKZL4',
    feedbackForm: 'https://forms.clickup.com/10554421/f/a231n-112251/XZ2VWQHCRFZGBPFSWP',
    supportForm: 'https://forms.clickup.com/10554421/f/a231n-114391/AGSXNY1DNY4FDHLANV',
  },
  sentry: {
    dsn: 'https://91c4ebe69d25894df101f60125a04613@o4507961791938560.ingest.us.sentry.io/4507967678906368',
  },
  SENTRY_AUTH_TOKEN:
    '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',
  googleAnalyticsId: '447446871',
};
